import { IClient } from '../interfaces/client.interface';

export const DATA_01: IClient = {
    id: 1,
    name: 'Acme Corp',
    inHouse: false,
};

export const DATA_02: IClient = {
    id: 2,
    name: 'Wonka Candy',
    inHouse: true,
    externalRef: '1234567890',
};

export const DATA_03: IClient = {
    id: 3,
    name: 'Krusty Krab',
    inHouse: false,
};

export const DATA_04: IClient = {
    id: 4,
    name: 'Aperture',
    inHouse: true,
};

export const DATA_05: IClient = {
    id: 5,
    name: 'Umbrella',
    inHouse: false,
};

export const DATA_06: IClient = {
    id: 6,
    name: 'Client with a really really really long name',
    inHouse: false,
};

export const DATA_07: IClient = {
    id: 7,
    name: 'Client_with_another_really_long_name',
    inHouse: false,
};

export const DATA_08: IClient = {
    id: 8,
    name: 'Client 8',
    inHouse: false,
};

export const DATA_09: IClient = {
    id: 9,
    name: 'Client 9',
    inHouse: false,
};

export const DATA_10: IClient = {
    id: 10,
    name: 'Client 10',
    inHouse: false,
};

export const ARRAY_OF_CLIENTS_01 = [ DATA_01, DATA_02, DATA_03, DATA_04, DATA_05, DATA_06, DATA_07, DATA_08, DATA_09, DATA_10 ];
export const ARRAY_OF_CLIENTS_02 = [ DATA_01, DATA_02, DATA_03, DATA_04 ];
export const ARRAY_OF_CLIENTS_03 = [ DATA_01, DATA_02, DATA_03, DATA_04, DATA_05 ];
